<h2 mat-dialog-title appLocalizationPopupDirective localizationCode="BuySellApproval">
    {{ 'BuySellApproval' | translate: {Default: "Buy Sell Approval"} }}
</h2>

<mat-dialog-content>
    <h6>{{ message }}</h6>

    <div>
        <p>Would you like to add comments for the employee?</p>

        <mat-form-field appearance="fill">
            <mat-label>
                {{ 'Comments' | translate: {Default: "Comments"} }}
            </mat-label>

            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="10"
                cdkAutosizeMaxRows="30" [(ngModel)]="comments"></textarea>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>

    <button color="warn" mat-raised-button appLocalizationPopupDirective localizationCode="DenyButton"
        appPreventDoubleClick (throttledClick)="save()" *ngIf="action === 'deny'">
        <mat-icon class="material-icons-outlined">cancel</mat-icon>
        {{ 'DenyButton' | translate: {Default: "Deny"} }}
    </button>
    <button class="green-chip" mat-raised-button appLocalizationPopupDirective localizationCode="ApproveButton"
        appPreventDoubleClick (throttledClick)="save()" *ngIf="action === 'approve'">
        <mat-icon class="material-icons-outlined">check_circle</mat-icon>
        {{ 'ApproveButton' | translate: {Default: "Approve"} }}
    </button>
</mat-dialog-actions>